<div class="toast-container">
  <div class="toast-alert" *ngIf="severity"><div class="icon" [ngClass]="severity"></div></div>
  <div class="toast-text" [ngClass]="font?.size">{{ pageContent?.message | translate }}</div>
  <div class="toast-close"><ion-button class="toast-button" [ngClass]="font?.size" color="toast-dark" (click)="hideToast()">{{ pageContent?.closeBtn | translate }}</ion-button></div>
</div>
